import { render, staticRenderFns } from "./HtmlButton.vue?vue&type=template&id=1bfbf422"
import script from "./HtmlButton.vue?vue&type=script&lang=ts"
export * from "./HtmlButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports